import getDefaultRoamingTimezones from './getDefaultRoamingTimezones';
import RoamingTimezone from '../store/schema/RoamingTimezone';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Gets the default value for the visible roaming timezones setting
 */
export default function getDefaultVisibleRoamingTimezones(): RoamingTimezone[] {
    if (!isFeatureEnabled('mon-multipleTimezones')) {
        return [];
    }

    return getDefaultRoamingTimezones().filter(timezone => timezone.isVisible);
}
